'use client'

import { ScoreboardGrid } from './Scoreboard'
import { useScoreboard } from '../hooks/use-scoreboard'
import { INTERNAL_API, SCOREBOARD_URL } from '../config/apis'
import Spin from './Spin'
import { isWeekend, isToday } from 'utils/date'

function sortMatchesByStatus(matches) {
  const statusOrder = {
    live: 0,
    scheduled: 1,
    paused: 2,
    finished: 3
  }

  return [...matches].sort((a, b) => {
    const orderA = statusOrder[a.status] ?? 999
    const orderB = statusOrder[b.status] ?? 999

    if (orderA !== orderB) {
      return orderA - orderB
    }
    const tournamentA = (a.tournament_name || '').toLowerCase()
    const tournamentB = (b.tournament_name || '').toLowerCase()

    if (tournamentA !== tournamentB) {
      return tournamentA.localeCompare(tournamentB)
    }
    const dateA = new Date(a.date).getTime()
    const dateB = new Date(b.date).getTime()
    return dateA - dateB
  })
}

function filterTodayMatches(matches) {
  const todayMatches = matches.filter((match) => {
    return isToday(match.date)
  })
  return todayMatches
}

export default function ScoreboardPage() {
  const weekend = isWeekend()

  const { matches, loading, lastUpdated } = useScoreboard(
    INTERNAL_API.SCOREBOARD_DATA,
    {
      pollingInterval: 30000,
      enablePolling: weekend
    }
  )

  if (!weekend) {
    return
  }

  if (loading && matches.length === 0) {
    return (
      <div className="mx-auto max-w-screen-2xl py-12 px-4">
        <div className="justify-center flex">
          <Spin color="text-blue" size="10" className="my-2 lg:my-8" />
        </div>
        <p className="text-black text-center opacity-50 text-[12px] font-alliance-medium lg:text-[20px]">
          Carregant marcadors...
        </p>
      </div>
    )
  }

  const todayMatches = filterTodayMatches(matches)
  const sortedMatches = sortMatchesByStatus(todayMatches)

  return (
    sortedMatches.length > 0 && (
      <div className="mx-auto max-w-screen-2xl py-12 px-4 sm:px-6 lg:px-8 lg:py-24">
        <div className="space-y-12">
          <div className="space-y-5 sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none">
            <div className="flex justify-between items-center">
              <h2 className="text-3xl font-bold tracking-tight sm:text-4xl text-[#082845]">
                Marcadors del dia
              </h2>

              {/* {lastUpdated && (
                  <div className="text-sm text-gray-500 flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
                    </svg>
                    {lastUpdated.toLocaleTimeString('ca-ES', {
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit'
                    })}
                  </div>
                )} */}
            </div>
          </div>
          <section>
            <ScoreboardGrid
              scoreboard={sortedMatches}
              basePath={SCOREBOARD_URL}
            />
          </section>
        </div>
      </div>
    )
  )
}
